import React, { useEffect, useState, useContext, useRef } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import PageServices from "../../services/PageServices";
import CommonServices from '../../services/ComanServices';


function VegaTable({ onSearchChange, searchValue, onTradingChange, onTradingChangetwo }) {
  const [data, setData] = useState([]);
  const [oldData, setOldData] = useState([]);
  // console.log("oldData", oldData)
  const { isLoggedIn, logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [processedData, setProcessedData] = useState([]);
  const [selectedStrikePrice, setSelectedStrikePrice] = useState(null);
  const [greekChainData, setGreekChainData] = useState([]);
  const [intraDay, setIntraDay] = useState('')
  const [chartData, setChartData] = useState([]);
  const [spotPrice, setSpotPrice] = useState(0);
  const [highestCEOIChange, setHighestCEOIChange] = useState(0);
  const [secondHighestCEOIChange, setSecondHighestCEOIChange] = useState(0);
  const [thirdHighestCEOIChange, setThirdHighestCEOIChange] = useState(0);

  const [highestCEOI, setHighestCEOI] = useState(0);
  const [secondHighestCEOI, setSecondHighestCEOI] = useState(0);
  const [thirdHighestCEOI, setThirdHighestCEOI] = useState(0);

  const [highestCEVolume, setHighestCEVolume] = useState(0);
  const [secondHighestCEVolume, setSecondHighestCEVolume] = useState(0);
  const [thirdHighestCEVolume, setThirdHighestCEVolume] = useState(0);
  const [highestPEOIChange, setHighestPEOIChange] = useState(0);
  const [secondHighestPEOIChange, setSecondHighestPEOIChange] = useState(0);
  const [thirdHighestPEOIChange, setThirdHighestPEOIChange] = useState(0);
  const [highestPEOI, setHighestPEOI] = useState(0);
  const [secondHighestPEOI, setSecondHighestPEOI] = useState(0);
  const [thirdHighestPEOI, setThirdHighestPEOI] = useState(0);
  const [highestPEVolume, setHighestPEVolume] = useState(0);
  const [secondHighestPEVolume, setSecondHighestPEVolume] = useState(0);
  const [thirdHighestPEVolume, setThirdHighestPEVolume] = useState(0);

  const [resistanceLevel, setResistanceLevel] = useState(null);
  const [supportLevel, setSupportLevel] = useState(null);
  const [futurePrice, setFutrePrice] = useState(0);
  const [previousHistory, setPreviousHistory] = useState([]);
  const [support, setSupport] = useState(0);
  const [resistance, setResistance] = useState(0);
  const [support2, setSupport2] = useState(0);
  const [resistance2, setResistance2] = useState(0);

  const [futureSupport, setFutureSupport] = useState(0);
  const [futureResistance, setFutureResistance] = useState(0);
  const [futureSupport2, setFutureSupport2] = useState(0);
  const [futureResistance2, setFutureResistance2] = useState(0);
  const [date, setDate] = useState(0);
  const [weeklyUpper, setWeeklyUpper] = useState(0);
  const [weeklyDown, setWeeklyDown] = useState(0);
  const [day, setDay] = useState(null);
  const [firstOptionChain, setFirstOptionChain] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedGreek, setSelectedGreek] = useState('');
  const [searchQuery, setSearchQuery] = React.useState("");
  const [showSearch, setShowSearch] = React.useState(false);





  const [rangeStart, setRangeStart] = useState('');
  const [rangeEnd, setRangeEnd] = useState('');
  const [rangeOptions, setRangeOptions] = useState([]);
  const [callOI, setCallOI] = useState(0);
  const [putOI, setPutOI] = useState(0);
  const [callOIChange, setCallOIChange] = useState(0);
  const [putOIChange, setPutOIChange] = useState(0);
  const [dataCallPutOIChange, setDataCallPutOIChange] = useState([]);
  const [dataCallPutOI, setDataCallPutOI] = useState([]);
  const [currentVegaCall, setCurrentVegaCall] = useState([]);
  const [currentStrikeCountCall, setCurrentStrikeCountCall] = useState([]);
  const [oldStrikeCountCall, setOldStrikeCountCall] = useState(0);
  const [oldVegaCall, setOldVegaCall] = useState(0);
  const [vegaCallDiff, setVegaCallDiff] = useState(0);
  const [strikeCountCallDiff, setStrikeCountCallDiff] = useState(0);
  const [currentVegaPut, setCurrentVegaPut] = useState([]);
  const [currentStrikeCountPut, setCurrentStrikeCountPut] = useState([]);
  const [oldStrikeCountPut, setOldStrikeCountPut] = useState(0);
  const [oldVegaPut, setOldVegaPut] = useState(0);
  const [vegaPutDiff, setVegaPutDiff] = useState(0);
  const [strikeCountPutDiff, setStrikeCountPutDiff] = useState(0);
  const [currentVegaPutDiff, setCurrentVegaPutDiff] = useState(0);
  const [currentStrikeCountPutDiff, setCurrentStrikeCountPutDiff] = useState(0);
  const [oldVegaPutDiff, setOldVegaPutDiff] = useState(0);
  const [oldStrikeCountPutDiff, setOldStrikeCountPutDiff] = useState(0);
  const [vegaCallAndPutDiff, setVegaCallAndPutDiff] = useState(0);
  const [strikeCountCallAndPutDiff, setStrikeCountCallAndPutDiff] = useState(0);




  const isInitialRangeSet = useRef(false);
  useEffect(() => {
    if (data && data.length > 0) {
      const prices = data.map(item => item.strikePrice);
      setRangeOptions(prices);

      if (!isInitialRangeSet.current) {
        setRangeStart(prices[0]);
        setRangeEnd(prices[prices.length - 1]);
        isInitialRangeSet.current = true; // Mark as initialized
      }
    }
  }, [data]);


  useEffect(() => {
    calculateOpenInterestChange();
  }, [rangeStart, rangeEnd, data]);

  const calculateOpenInterestChange = () => {
    if (!data || data.length === 0) return;

    // Filter kar rahe strike prices ke range ke andar
    const filteredData = data.filter(item => {
      const strike = parseFloat(item.strikePrice);
      return strike >= parseFloat(rangeStart) && strike <= parseFloat(rangeEnd);
    });

    // CE and PE OpenInterestChange ka total
    let totalCallOIChange = 0;
    let totalPutOIChange = 0;
    let totalCallOI = 0;
    let totalPutOI = 0;

    filteredData.forEach(item => {
      if (item.CE) {
        totalCallOIChange += item.CE.OpenInterestChange || 0;
        totalCallOI += item.CE.OpenInterest || 0;
      }
      if (item.PE) {
        totalPutOIChange += item.PE.OpenInterestChange || 0;
        totalPutOI += item.PE.OpenInterest || 0;
      }
    });

    setCallOIChange(totalCallOIChange / 100000);
    setPutOIChange(totalPutOIChange / 100000);
    setCallOI(totalCallOI / 100000);
    setPutOI(totalPutOI / 100000);




    setDataCallPutOIChange([
      { name: "CALL", value: totalCallOIChange / 1000 },
      { name: "PUT", value: totalPutOIChange / 1000 }
    ]);
    setDataCallPutOI([
      { name: "CALL", value: totalCallOI / 1000 },
      { name: "PUT", value: totalPutOI / 1000 }
    ]);
  };



  // If you're fetching data, adjust this dependency array

  // console.log("day", day);
  // console.log("WeeklyUpper", weeklyUpper);
  // console.log("WeeklyDown", weeklyDown);
  const fetchData = async () => {
    try {

      // count ema 
      function calculateEMA(values, period = 3) {
        let ema = values[2]?.Low; // Start with the first value as the initial EMA
        const smoothingFactor = 2 / (period + 1); // Smoothing factor (multiplier)

        for (let i = 1; i >= 0; i--) {
          ema = (smoothingFactor * values[i].Low) + ((1 - smoothingFactor) * ema);
        }

        return ema;
      }
      let response

      if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER" || localStorage.getItem('stock') === 'CRUDEOIL' || localStorage.getItem("stock") === "COPPER" || localStorage.getItem("stock") === "NATURALGAS") {

        response = await PageServices.getComodityOptionChain({
          symbolToken: localStorage.getItem("stock"),
        });
        console.log(">>>>>>>>>res1", response);
      } else {

        response = await PageServices.getOptionChain({
          symbolToken: localStorage.getItem("stock"),
        });
        response.formattedData.sort((x, y) => parseFloat(x.strikePrice) - parseFloat(y.strikePrice));
        // console.log(">>>>>>>>>res123",res123);
      }


      PageServices.getDataForSuportandRessitans(localStorage.getItem("stock")).then((response) => {
        setFirstOptionChain(response);
        //  console.log(response);
      }).catch((error) => {
        console.error('Error fetching data for support and ressitance:', error);
      });

      // Ensure response.sub and response.future exist before accessing them
      setSpotPrice(response?.spotPrice?.LastTradePrice ?? 0);
      setFutrePrice(response?.futurePrice?.LastTradePrice ?? 0);
      onTradingChange(response?.historical);
      setPreviousHistory(response?.historical);
      const currentDate = new Date();

      // Extract the components from the date
      const month = currentDate.toLocaleString('default', { month: 'short' });  // Short month name (e.g., "Dec")
      const day = String(currentDate.getDate()).padStart(2, '0');  // Day with leading zero if necessary
      const year = currentDate.getFullYear();  // Full year (e.g., 2024)
      const hours = String(currentDate.getHours()).padStart(2, '0');  // Hours with leading zero
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');  // Minutes with leading zero
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');  // Seconds with leading zero

      // Combine them into the desired format
      const formattedDate = `${month} ${day} ${hours}:${minutes}:${seconds}`;

      setDate(formattedDate);

      const emaLow = calculateEMA(response?.historicalResponseEx?.Result)


      // console.log("emaLow",emaLow    ,response?.historicalResponseEx?.Result[0].Close )
      if (response?.historicalResponseEx?.Result[0].Close > emaLow) {

        onTradingChangetwo('Bullish');
        // console.log(emaLow,"Bullish: Close is greater than EMA",response?.historicalResponseEx?.Result[0]?.close);
      } else {
        // console.log("Bearish: Close is less than EMA");
        onTradingChangetwo('Bearish');
      }

      if (Array.isArray(response?.formattedData)) {
        let middleValues = response?.formattedData
        let midleIndex;
        response.formattedData.some((item, index) => {
          if (item?.strikePrice >= response?.spotPrice?.LastTradePrice) {
            midleIndex = index;
            return true;  // This will stop the iteration
          }
          return false;
        });


        let upperIndex;
        let lowerIndex;

        if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER" || localStorage.getItem('stock') === 'CRUDEOIL' || localStorage.getItem("stock") === "COPPER" || localStorage.getItem("stock") === "NATURALGAS") {

          upperIndex = Math.max(midleIndex - 40, 0);  // Prevent negative indices
          lowerIndex = Math.min(midleIndex + 40, middleValues.length);
        } else {
          upperIndex = Math.max(midleIndex - 20, 0);  // Prevent negative indices
          lowerIndex = Math.min(midleIndex + 20, middleValues.length);
        }
        const finalData = middleValues.slice(upperIndex, lowerIndex)

        if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER") {

          let step;
          let currentValue
          // localStorage.getItem("stock") === "GOLD" ? currentValue = 85000 : currentValue = 80000 
          localStorage.getItem("stock") === "GOLD" ? step = 500 : step = 1000
          // Convert strike prices to numbers and sort
          const strikePrices = finalData.map(item => parseInt(item.strikePrice)).sort((a, b) => a - b);

          // Find the first strike price that ends with '000'
          currentValue = strikePrices.find(price => price % 1000 === 0);

          const filteredArray = finalData.filter(value => {
            if (value.strikePrice == currentValue) {
              currentValue += step; // increment the current value
              return true;
            }
            return false;
          });
          console.log("filteredArray", filteredArray)
          setData(filteredArray);
          console.log(">>data1", data)
        } else {
          if (localStorage.getItem('reverseTable') === "true") {
            finalData.reverse();
          }
          setData(finalData);

          // console.log(">>data2", data)
        }



        // Find the highest and second-highest values for each column
        const ceOpenInterestChanges = [
          ...new Set(
            finalData.map(
              (item) => item.CE?.OpenInterestChange ?? 0
            )
          ),
        ].sort((a, b) => b - a);

        const ceOpenInterests = [
          ...new Set(
            finalData.map((item) => item.CE?.OpenInterest ?? 0)
          ),
        ].sort((a, b) => b - a);
        const ceTotalQtyTraded = [
          ...new Set(
            finalData.map((item) => item.CE?.TotalQtyTraded ?? 0)
          ),
        ].sort((a, b) => b - a);
        const peOpenInterestChanges = [
          ...new Set(
            finalData.map(
              (item) => item.PE?.OpenInterestChange ?? 0
            )
          ),
        ].sort((a, b) => b - a);
        const peOpenInterests = [
          ...new Set(
            finalData.map((item) => item.PE?.OpenInterest ?? 0)
          ),
        ].sort((a, b) => b - a);
        const peTotalQtyTraded = [
          ...new Set(
            finalData.map((item) => item.PE?.TotalQtyTraded ?? 0)
          ),
        ].sort((a, b) => b - a);

        const setValues = (values, setHighest, setSecond, setThird) => {
          setHighest(values[0] || 0);
          setSecond(values[1] || 0);
          setThird(values[2] || 0);
        };

        setValues(
          ceOpenInterestChanges,
          setHighestCEOIChange,
          setSecondHighestCEOIChange,
          setThirdHighestCEOIChange
        );
        setValues(
          ceOpenInterests,
          setHighestCEOI,
          setSecondHighestCEOI,
          setThirdHighestCEOI
        );
        setValues(
          ceTotalQtyTraded,
          setHighestCEVolume,
          setSecondHighestCEVolume,
          setThirdHighestCEVolume
        );
        setValues(
          peOpenInterestChanges,
          setHighestPEOIChange,
          setSecondHighestPEOIChange,
          setThirdHighestPEOIChange
        );
        setValues(
          peOpenInterests,
          setHighestPEOI,
          setSecondHighestPEOI,
          setThirdHighestPEOI
        );
        setValues(
          peTotalQtyTraded,
          setHighestPEVolume,
          setSecondHighestPEVolume,
          setThirdHighestPEVolume
        );

        const maxCEOI = Math.max(
          ...response.formattedData.map((item) => item.CE?.OpenInterest || 0)
        );
        const maxPEOI = Math.max(
          ...response.formattedData.map((item) => item.PE?.OpenInterest || 0)
        );
        const resistance = response.formattedData.find(
          (item) => item.CE?.OpenInterest === maxCEOI
        )?.strikePrice;
        const support = response.formattedData.find(
          (item) => item.PE?.OpenInterest === maxPEOI
        )?.strikePrice;
        setResistanceLevel(resistance);
        setSupportLevel(support);
      } else {
        // If formattedData is not an array, set loading to false
        setLoading(false);
        // console.error("Invalid formattedData:", response.formattedData);
      }

      setLoading(false);
    } catch (error) {
      // console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    let intervalId;
    setLoading(true);
    if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER") {
      intervalId = setInterval(fetchData, 15000);
    } else {
      intervalId = setInterval(fetchData, 5000);
    }

    return () => clearInterval(intervalId);
  }, [searchValue]);

  //   const handleTimeChange = (time) => {
  //     setSelectedTime(time);
  // };

  React.useEffect(() => {

    fetchHistoricalData();

  }, []);

  const fetchHistoricalData = async () => {


    try {
      const response = await PageServices.getOldData({
        date: "26-Jun-2025", // You can make this dynamic as needed
        time: "14:07",       // You can make this dynamic as needed
        symbolToken: localStorage.getItem("stock"),
      });
      console.log("Historical Data Response:", response);

      if (response && response.data) {

        const spot = await PageServices.getOldSpot({
          date: "28-May-2025", // You can make this dynamic as needed
          time: "09:41",       // You can make this dynamic as needed
          symbolToken: localStorage.getItem("stock"),
        })

        if (spot && spot.data) {
          // console.log("spot",spot)
          setSpotPrice(spot?.data?.spotPrice?.LastTradePrice);
        }

        const options = response.data; // Extract the options array
        // setSpotPrice(24945);
        setOldData(options);

        // console.log(response?.data?.spotPrice?.LastTradePrice)

        // Find the highest and second-highest values for each column
        const ceOpenInterestChanges = [...new Set(options.map(item => item.CE?.OpenInterestChange ?? 0))].sort((a, b) => b - a);
        const ceOpenInterests = [...new Set(options.map(item => item.CE?.OpenInterest ?? 0))].sort((a, b) => b - a);
        const ceTotalQtyTraded = [...new Set(options.map(item => item.CE?.TotalQtyTraded ?? 0))].sort((a, b) => b - a);
        const peOpenInterestChanges = [...new Set(options.map(item => item.PE?.OpenInterestChange ?? 0))].sort((a, b) => b - a);
        const peOpenInterests = [...new Set(options.map(item => item.PE?.OpenInterest ?? 0))].sort((a, b) => b - a);
        const peTotalQtyTraded = [...new Set(options.map(item => item.PE?.TotalQtyTraded ?? 0))].sort((a, b) => b - a);

        const setValues = (values, setHighest, setSecond, setThird) => {
          setHighest(values[0] || 0);
          setSecond(values[1] || 0);
          setThird(values[2] || 0);
        };

        setValues(ceOpenInterestChanges, setHighestCEOIChange, setSecondHighestCEOIChange, setThirdHighestCEOIChange);
        setValues(ceOpenInterests, setHighestCEOI, setSecondHighestCEOI, setThirdHighestCEOI);
        setValues(ceTotalQtyTraded, setHighestCEVolume, setSecondHighestCEVolume, setThirdHighestCEVolume);
        setValues(peOpenInterestChanges, setHighestPEOIChange, setSecondHighestPEOIChange, setThirdHighestPEOIChange);
        setValues(peOpenInterests, setHighestPEOI, setSecondHighestPEOI, setThirdHighestPEOI);
        setValues(peTotalQtyTraded, setHighestPEVolume, setSecondHighestPEVolume, setThirdHighestPEVolume);

        const maxCEOI = Math.max(...options.map(item => item.CE?.OpenInterest || 0));
        const maxPEOI = Math.max(...options.map(item => item.PE?.OpenInterest || 0));
        const resistance = options.find(item => item.CE?.OpenInterest === maxCEOI)?.strikePrice;
        const support = options.find(item => item.PE?.OpenInterest === maxPEOI)?.strikePrice;

        setResistanceLevel(resistance);
        setSupportLevel(support);
      } else {
        setData([]); // Handle case where options are not present
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchHistoryData = async () => {
      try {
        const response = await PageServices.getOldData({
          date: "28-May-2025",
          time: "09:41",
          symbolToken: localStorage.getItem("stock"),
        });

        console.log("✅ History API Response:", response);

        const processData = (data) => {
          return data?.map((entry) => ({
            ...entry,
            LastTradeTime: new Date(entry.LastTradeTime * 1000).toLocaleTimeString(),
          }));
        };

        const dataSet = processData(response.data);
        setProcessedData(dataSet);
      } catch (error) {
        console.error("❌ Error fetching historical data:", error);
      }
    };

    fetchHistoryData();
  }, []);


  const fetchGreekChainData = (instrument) => {
    PageServices.getOptionGreekChain({
      instrument,
    })
      .then((response) => {
        const processData = response.map((entry) => ({
          time: new Date(entry.LastTradeTime * 1000).toLocaleTimeString(),
          OI: entry.OpenInterest,
          OIChange: entry.OIChange,
          Volume: entry.Volume,
        }));
        setGreekChainData(processData);
      })
      .catch((error) => console.log(error));
  };
  const onHistoricsMultipleClick = (data) => {
    console.log(data);
    PageServices.getHistorydataOichg({
      instrumentIdentifier: data.InstrumentIdentifier,
      date: "20-may-2025",
      symbolToken: localStorage.getItem("stock"),
    })
      .then((response) => {
        console.log("response1234", response);

        const processChartData = (data) => {
          const ceData = data.data.ce;
          const peData = data.data.pe;

          return ceData.map((ceItem, index) => {
            const peItem = peData[index];
            return {
              time: new Date(ceItem.LastTradeTime * 1000).toLocaleTimeString(),
              ceOI: ceItem.OpenInterest,
              peOI: peItem.OpenInterest,
              oiDifference:
                peItem.OpenInterest - ceItem.OpenInterest,
              ceOIChange: ceItem.OpenInterestChange,
              peOIChange: peItem.OpenInterestChange,
              oiChgDifference: peItem.OpenInterestChange - ceItem.OpenInterestChange,
              ceVolume: ceItem.TotalQtyTraded,
              peVolume: peItem.TotalQtyTraded,
              volumeDifference: peItem.TotalQtyTraded - ceItem.TotalQtyTraded,
              volumedevide: ceItem.TotalQtyTraded / peItem.TotalQtyTraded,
              ceLtp: ceItem.LastTradePrice,
              peLtp: peItem.LastTradePrice,
              pcrOi: ceItem.OpenInterest !== 0
                ? peItem.OpenInterest / ceItem.OpenInterest
                : 0,
              pcrOiChange: ceItem.OpenInterestChange !== 0
                ? peItem.OpenInterestChange / ceItem.OpenInterestChange
                : 0
            };
          });
        };
        setChartData(processChartData(response));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formatTime = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":");
    const suffix = hours >= 12 ? "PM" : "AM";
    const adjustedHours = hours % 12 || 12;
    return `${adjustedHours}:${minutes} ${suffix}`;
  };
  // Modal trigger
  const onModalOpen = (instrument) => {
    fetchGreekChainData(instrument); // Fetch data when the modal opens
  };

  const getSpotPriceRow = () => {
    if (spotPrice) {


      return (
        <tr key="spot-price">
          <td colSpan={5}></td>
          <td className="strike-pric spot-price">
            <button
              style={{
                background: "#004894",
                color: "#fff",
                borderRadius: "35px",
                padding: "8px 30px",
              }}
            >
              {/* {localStorage.getItem('showFuturePrice')==='true' || null ? `F : ${futurePrice}` : ' '} * Spot : {spotPrice} * F-S : {(futurePrice - spotPrice).toFixed(1)} */}
              F : {futurePrice} * Spot : {spotPrice} * F-S : {(futurePrice - spotPrice).toFixed(1)}
            </button>
          </td>
          <td colSpan={5}></td>
        </tr>
      );
    }
  };


  const formatNumber = (value) => {
    let useValue;
    if (localStorage.getItem('showQt') === "true") {
      // console.log(localStorage.getItem('expiry'))
      useValue = value / Number(localStorage.getItem('expiry'))
    } else {
      useValue = value
    }
    if (localStorage.getItem('showNumbers') === 'true') {

      return useValue.toLocaleString('en-IN');
    } else {
      if (value >= 100000) {
        return `${(value / 100000).toFixed(2)}L`; // Format as lakhs
      } else if (value >= 1000) {
        return `${(value / 1000).toFixed(2)}k`; // Format as thousands
      } else {
        return value; // Return as is
      }
    }

  };

  const calculatePercentage = (value, highestValue) => {
    if (highestValue === 0) return 0;
    return ((value / highestValue) * 100).toFixed(2);
  };

  // Step 1: Prepare the data
  useEffect(() => {
    if (!data || data.length === 0) return;

    const ceOptions = data
      .filter(item => item?.CE && item.strikePrice)
      .map(item => ({
        strikePrice: parseInt(item.strikePrice),
        change: item.CE?.OpenInterestChange ?? 0,
        OI: item.CE?.OpenInterest ?? 0,
        volume: item.CE?.TotalQtyTraded ?? 0,
        vega: item.CE?.Vega ?? 0
      }));

    function getTopStrikesBy(key) {
      const sorted = [...ceOptions].sort((a, b) => b[key] - a[key]);
      const topThree = sorted.slice(0, 3);

      const highestVal = topThree[0]?.[key] ?? 0;
      const validTops = topThree
        .filter(item => (item[key] / highestVal) * 100 >= 75)
        .map(item => item.strikePrice);

      return validTops;
    }

    const changeTops = getTopStrikesBy("change");
    const oiTops = getTopStrikesBy("OI");
    const volumeTops = getTopStrikesBy("volume");

    const allTopStrikes = Array.from(new Set([
      ...changeTops,
      ...oiTops,
      ...volumeTops
    ]));

    if (allTopStrikes.length < 2) {
      console.log("Not enough valid top CE strikes to calculate range.");
      return;
    }

    const minStrike = Math.min(...allTopStrikes);
    const maxStrike = Math.max(...allTopStrikes);

    const strikesInRange = ceOptions.filter(
      item => item.strikePrice >= minStrike && item.strikePrice <= maxStrike
    );

    const strikeCount = strikesInRange.length;
    const totalVega = strikesInRange.reduce((sum, item) => sum + item.vega, 0);

    setCurrentStrikeCountCall(strikeCount);
    setCurrentVegaCall(totalVega);

    console.log("👉 Vega and count between top CE strike range:", {
      strikeCount,
      totalVega,
      range: [minStrike, maxStrike]
    });
  }, [data]);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const peOptions = data
      .filter(item => item?.PE && item.strikePrice)
      .map(item => ({
        strikePrice: parseInt(item.strikePrice),
        change: item.PE?.OpenInterestChange ?? 0,
        OI: item.PE?.OpenInterest ?? 0,
        volume: item.PE?.TotalQtyTraded ?? 0,
        vega: item.PE?.Vega ?? 0
      }));

    function getTopStrikesByPE(key) {
      const sorted = [...peOptions].sort((a, b) => b[key] - a[key]);
      const topThree = sorted.slice(0, 3);

      const highestVal = topThree[0]?.[key] ?? 0;
      const validTops = topThree
        .filter(item => (item[key] / highestVal) * 100 >= 75)
        .map(item => item.strikePrice);

      return validTops;
    }

    const changeTopsPE = getTopStrikesByPE("change");
    const oiTopsPE = getTopStrikesByPE("OI");
    const volumeTopsPE = getTopStrikesByPE("volume");

    const allTopStrikesPE = Array.from(new Set([
      ...changeTopsPE,
      ...oiTopsPE,
      ...volumeTopsPE
    ]));

    if (allTopStrikesPE.length < 2) {
      console.log("Not enough valid top PE strikes to calculate range.");
      return;
    }

    const minStrikePE = Math.min(...allTopStrikesPE);
    const maxStrikePE = Math.max(...allTopStrikesPE);

    const strikesInRangePE = peOptions.filter(
      item => item.strikePrice >= minStrikePE && item.strikePrice <= maxStrikePE
    );

    const strikeCountPE = strikesInRangePE.length;
    const totalVegaPE = strikesInRangePE.reduce((sum, item) => sum + item.vega, 0);

    setCurrentStrikeCountPut(strikeCountPE);
    setCurrentVegaPut(totalVegaPE);

    console.log("👉 Vega and count between top PE strike range:", {
      strikeCount: strikeCountPE,
      totalVega: totalVegaPE,
      range: [minStrikePE, maxStrikePE]
    });
  }, [data]); // Dependency array – only runs when data changes

  // old data vega
  useEffect(() => {
    if (!oldData || oldData.length === 0) return;
    // console.log("hello")
    const ceOptions = oldData
      .filter(item => item?.CE && item.strikePrice)
      .map(item => ({
        strikePrice: parseInt(item.strikePrice),
        change: item.CE?.OpenInterestChange ?? 0,
        OI: item.CE?.OpenInterest ?? 0,
        volume: item.CE?.TotalQtyTraded ?? 0,
        vega: item.CE?.Vega ?? 0
      }));

    function getTopStrikesBy(key) {
      const sorted = [...ceOptions].sort((a, b) => b[key] - a[key]);
      const topThree = sorted.slice(0, 3);

      const highestVal = topThree[0]?.[key] ?? 0;
      const validTops = topThree
        .filter(item => (item[key] / highestVal) * 100 >= 75)
        .map(item => item.strikePrice);

      return validTops;
    }

    const changeTops = getTopStrikesBy("change");
    const oiTops = getTopStrikesBy("OI");
    const volumeTops = getTopStrikesBy("volume");

    const allTopStrikes = Array.from(new Set([
      ...changeTops,
      ...oiTops,
      ...volumeTops
    ]));

    if (allTopStrikes.length < 2) {
      console.log("Not enough valid top CE strikes to calculate range.");
      return;
    }

    const minStrike = Math.min(...allTopStrikes);
    const maxStrike = Math.max(...allTopStrikes);

    const strikesInRange = ceOptions.filter(
      item => item.strikePrice >= minStrike && item.strikePrice <= maxStrike
    );

    const strikeCount = strikesInRange.length;
    const totalVega = strikesInRange.reduce((sum, item) => sum + item.vega, 0);

    setOldStrikeCountCall(strikeCount);
    setOldVegaCall(totalVega);        // You may want to rename to `setOldVegaCall`

    console.log("👉 Old Vega and count between top CE strike range:", {
      strikeCount,
      totalVega,
      range: [minStrike, maxStrike]
    });
  }, [oldData]);


  useEffect(() => {
    if (!oldData || oldData.length === 0) return;

    // Step 1: Build PE options array with all required fields
    const peOptions = oldData
      .filter(item => item?.PE && item.strikePrice)
      .map(item => ({
        strikePrice: parseInt(item.strikePrice),
        change: item.PE?.OpenInterestChange ?? 0,
        OI: item.PE?.OpenInterest ?? 0,
        volume: item.PE?.TotalQtyTraded ?? 0,
        vega: item.PE?.Vega ?? 0
      }));

    // Debug: Log all PE options with Vega values
    // console.log("📊 PE Vega values from oldData:");
    // peOptions.forEach(p => {
    //   console.log(`Strike ${p.strikePrice}: Vega = ${p.vega}`);
    // });

    // Step 2: Get top strikes by any key
    function getTopStrikesBy(key) {
      const sorted = [...peOptions].sort((a, b) => b[key] - a[key]);
      const topThree = sorted.slice(0, 3);

      const highestVal = topThree[0]?.[key] ?? 0;
      const validTops = topThree
        .filter(item => (item[key] / highestVal) * 100 >= 75)
        .map(item => item.strikePrice);

      return validTops;
    }

    const changeTops = getTopStrikesBy("change");
    const oiTops = getTopStrikesBy("OI");
    const volumeTops = getTopStrikesBy("volume");

    // Step 3: Merge top strikes
    const allTopStrikes = Array.from(new Set([
      ...changeTops,
      ...oiTops,
      ...volumeTops
    ]));

    if (allTopStrikes.length < 2) {
      console.log("⚠️ Not enough valid top PE strikes to calculate range.");
      return;
    }

    const minStrike = Math.min(...allTopStrikes);
    const maxStrike = Math.max(...allTopStrikes);

    // Step 4: Filter strikes within the range and calculate vega
    const strikesInRange = peOptions.filter(
      item => item.strikePrice >= minStrike && item.strikePrice <= maxStrike
    );

    const strikeCount = strikesInRange.length;
    const totalVega = strikesInRange.reduce((sum, item) => sum + item.vega, 0);

    // Step 5: Set states and log
    setOldStrikeCountPut(strikeCount);
    setOldVegaPut(totalVega);

    console.log("👉 old Vega and count between top PE strike range:", {
      strikeCount,
      totalVega,
      range: [minStrike, maxStrike]
    });
  }, [oldData]);
  useEffect(() => {
    // Ensure all required values are available
    if (
      typeof currentVegaCall === 'number' &&
      typeof oldVegaCall === 'number' &&
      typeof currentStrikeCountCall === 'number' &&
      typeof oldStrikeCountCall === 'number'
    ) {
      const vegaDiff = currentVegaCall - oldVegaCall;
      const strikeDiff = currentStrikeCountCall - oldStrikeCountCall;

      setVegaCallDiff(vegaDiff);
      setStrikeCountCallDiff(strikeDiff);

      console.log("📊 CE Vega Difference:", vegaDiff);
      console.log("📊 CE Strike Count Difference:", strikeDiff);
    }
  }, [currentVegaCall, oldVegaCall, currentStrikeCountCall, oldStrikeCountCall]);

  useEffect(() => {
  // Ensure all values are available and are numbers
  if (
    typeof currentVegaPut === 'number' &&
    typeof oldVegaPut === 'number' &&
    typeof currentStrikeCountPut === 'number' &&
    typeof oldStrikeCountPut === 'number'
  ) {
    const vegaDiff = currentVegaPut - oldVegaPut;
    const strikeDiff = currentStrikeCountPut - oldStrikeCountPut;

    setVegaPutDiff(vegaDiff);
    setStrikeCountPutDiff(strikeDiff);

    console.log("✅ PE Vega Difference:", vegaDiff);
    console.log("✅ PE Strike Count Difference:", strikeDiff);
  }
}, [currentVegaPut, oldVegaPut, currentStrikeCountPut, oldStrikeCountPut]);
useEffect(() => {
  // Ensure all values are numbers before doing math
  const vegaCall = Number(currentVegaCall);
  const vegaPut = Number(currentVegaPut);
  const strikeCall = Number(currentStrikeCountCall);
  const strikePut = Number(currentStrikeCountPut);

  setCurrentVegaPutDiff(vegaPut - vegaCall);
  setCurrentStrikeCountPutDiff(strikePut - strikeCall);
}, [currentVegaCall, currentVegaPut, currentStrikeCountCall, currentStrikeCountPut]);

useEffect(() => {
  // Ensure all values are numbers before doing math
  const vegaCall = Number(oldVegaCall);
  const vegaPut = Number(oldVegaPut);
  const strikeCall = Number(oldStrikeCountCall);
  const strikePut = Number(oldStrikeCountPut);

  setOldVegaPutDiff(vegaPut - vegaCall);
  setOldStrikeCountPutDiff(strikePut - strikeCall);
}, [oldVegaCall, oldVegaPut, oldStrikeCountCall, oldStrikeCountPut]);

useEffect(() => {
  // Ensure all values are numbers before doing math
  const vegaCall = Number(vegaCallDiff);
  const vegaPut = Number(vegaPutDiff);
  const strikeCall = Number(strikeCountCallDiff);
  const strikePut = Number(strikeCountPutDiff);

  setVegaCallAndPutDiff(vegaPut - vegaCall);
  setStrikeCountCallAndPutDiff(strikePut - strikeCall);
}, [vegaCallDiff, vegaPutDiff, strikeCountCallDiff, strikeCountPutDiff]);


  const cellStyle = {
    padding: "8px 12px",
    border: "1px solid #444",
    textAlign: "center"
  };

  const vegaCallData = [
  { label: "Day Open", vega: oldVegaCall, count: oldStrikeCountCall },
  { label: "Current", vega: currentVegaCall, count: currentStrikeCountCall },
  { label: "Difference", vega: vegaCallDiff, count: strikeCountCallDiff }
];
const vegaPutData = [
  { label: "Day Open", vega: oldVegaPut, count: oldStrikeCountPut },
  { label: "Current", vega: currentVegaPut, count: currentStrikeCountPut },
  { label: "Difference", vega: vegaPutDiff, count: strikeCountPutDiff }
];
const vegaCallAndPutDifferenceData = [
  { label: "Day Open", vega: oldVegaPutDiff, count: oldStrikeCountPutDiff },
  { label: "Current", vega: currentVegaPutDiff, count: currentStrikeCountPutDiff },
  { label: "Difference", vega: vegaCallAndPutDiff, count: strikeCountCallAndPutDiff }
];

  return (


    <div>
      <div style={{ overflowX: "auto" }}>
        <h3 style={{ textAlign: "center" }} >Call</h3>
        <table style={{ borderCollapse: "collapse", width: "70%" }}>
          <thead>
            <tr style={{ backgroundColor: "#333", color: "#fff" }}>
              <th style={cellStyle}> </th>
              <th style={cellStyle}>Vega</th>
              <th style={cellStyle}>Count</th>
            </tr>
          </thead>
          <tbody>
            {vegaCallData.map((row, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#222" : "#111", color: "#fff" }}>
                <td style={cellStyle}>{row.label}</td>
                <td style={cellStyle}>{Number(row.vega).toFixed(4)}</td>

                <td style={cellStyle}>{row.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ overflowX: "auto", marginTop: "30px" }}>
        <h3 style={{ textAlign: "center" }} >Put</h3>
        <table style={{ borderCollapse: "collapse", width: "70%" }}>
          <thead>
            <tr style={{ backgroundColor: "#333", color: "#fff" }}>
              <th style={cellStyle}> </th>
              <th style={cellStyle}>Vega</th>
              <th style={cellStyle}>Count</th>
            </tr>
          </thead>
          <tbody>
            {vegaPutData.map((row, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#222" : "#111", color: "#fff" }}>
                <td style={cellStyle}>{row.label}</td>
                <td style={cellStyle}>{Number(row.vega).toFixed(4)}</td>
                <td style={cellStyle}>{row.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ overflowX: "auto", marginTop: "30px" }}>
        <h3 style={{ textAlign: "center" }} >Difference Put & Call</h3>
        <table style={{ borderCollapse: "collapse", width: "70%" }}>
          <thead>
            <tr style={{ backgroundColor: "#333", color: "#fff" }}>
              <th style={cellStyle}> </th>
              <th style={cellStyle}>Vega</th>
              <th style={cellStyle}>Count</th>
            </tr>
          </thead>
          <tbody>
            {vegaCallAndPutDifferenceData.map((row, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#222" : "#111", color: "#fff" }}>
                <td style={cellStyle}>{row.label}</td>
                <td style={cellStyle}>{Number(row.vega).toFixed(4)}</td>

                <td style={cellStyle}>{row.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ======== Search Nifty popup ======== */}
      <div
        className="modal fade"
        id="searchNiftyModel"
        tabIndex={-1}
        aria-labelledby="searchNiftyModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-green">
            <div className="modal-body py-4 px-4">
              <form className="search-field-container">
                <div className="form-input">
                  <input
                    type="search"
                    name="Search Nifty"
                    className="form-control"
                    placeholder="Search Stock/Index"
                  />
                </div>
              </form>
              <div className="nifty-index-list">
                <ul className="list-unstyled">
                  <li>
                    <button>Banknifty</button>
                  </li>
                  <li>
                    <button>Finnifty</button>
                  </li>
                  <li>
                    <button>Nifty_Mid_Select</button>
                  </li>
                  <li>
                    <button>Nifty</button>
                  </li>
                  <li>
                    <button>Naturalgas</button>
                  </li>
                  <li>
                    <button>Crudeoil</button>
                  </li>
                  <li>
                    <button>Usdinr</button>
                  </li>
                  <li>
                    <button>Sensex</button>
                  </li>
                  <li>
                    <button>bankex</button>
                  </li>
                  <li>
                    <button>Aartiind</button>
                  </li>
                  <li>
                    <button>Sensex</button>
                  </li>
                  <li>
                    <button>bankex</button>
                  </li>
                  <li>
                    <button>Aartiind</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ======== Search Nifty popup ======== */}
      <div
        className="modal fade"
        id="searchNiftyModel"
        tabIndex={-1}
        aria-labelledby="searchNiftyModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-green">
            <div className="modal-body py-4 px-4">
              <form className="search-field-container">
                <div className="form-input">
                  <input
                    type="search"
                    name="Search Nifty"
                    className="form-control"
                    placeholder="Search Stock/Index"
                  />
                </div>
              </form>
              <div className="nifty-index-list">
                <ul className="list-unstyled">
                  <li>
                    <button>Banknifty</button>
                  </li>
                  <li>
                    <button>Finnifty</button>
                  </li>
                  <li>
                    <button>Nifty_Mid_Select</button>
                  </li>
                  <li>
                    <button>Nifty</button>
                  </li>
                  <li>
                    <button>Naturalgas</button>
                  </li>
                  <li>
                    <button>Crudeoil</button>
                  </li>
                  <li>
                    <button>Usdinr</button>
                  </li>
                  <li>
                    <button>Sensex</button>
                  </li>
                  <li>
                    <button>bankex</button>
                  </li>
                  <li>
                    <button>Aartiind</button>
                  </li>
                  <li>
                    <button>Sensex</button>
                  </li>
                  <li>
                    <button>bankex</button>
                  </li>
                  <li>
                    <button>Aartiind</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default VegaTable;
